<template>
  <div class="task-title">
    <b-modal v-model="showRemoveTask" type="warn" title="Confirm Deletion" @ok="removeTask(task.id)" @hidden="removeDeleteIcons" ok-title="Yes, Delete">
			<p>Are you sure you want to delete task?</p>
		</b-modal>
    <b-modal v-model="showRemoveTaskErr" title="Task could not be deleted" ok-only>
			<p>A deliverable must have at least one task.</p>
		</b-modal>
    <!--
      <b-modal v-model="showRemoveApprovalTaskErr" title="Task could not be deleted" ok-only>
        <p>Approval tasks for social media deliverables can not be removed.</p>
      </b-modal>
      <b-modal v-model="showRemovePublishTaskErr" title="Task could not be deleted" ok-only>
        <p>Publishing tasks for social media deliverables can not be removed.</p>
      </b-modal>
    -->
    <div v-if="index == 0" @click="sortTasks({sortKey: 'created_date', deliverables: fullDeliverables})" class="az task-table-header__task exclude-outside-click cursor-pointer" :class="getSortingClass()">
      Tasks <span class="task-count-second">({{totalTasks}})</span>
      <b-button 
      v-if="!(!userAbilities.editMediaCall || (deliverable && deliverable.permissions && deliverable.permissions.viewOnly))" 
      variant="theme" class="add-task-btn" @click.stop="createTask">
        Add Task
        <div role="status" v-show="addingTask" class="ml-2 spinner-border spinner-border-sm text-primary"><span class="sr-only">Loading...</span></div>
      </b-button>
      <SortTaskControl />
    </div>

    <div class="field-wrap">
      <div @click="showField">
        <div :style="taskStatusColor(task)" 
        v-if="!(!userAbilities.editMediaCall || (deliverable && deliverable.permissions && deliverable.permissions.viewOnly))" 
        :class="`checkbox-wrap ${removeButtonClickedOnce ? 'hovered' : ''}`" v-b-tooltip.hover title="Delete task" @click.stop="deleteTaskClick" v-click-outside="deleteOutside">
          <span>
            <i class="fas fa-trash"></i>
          </span>
        </div>
        <span
          v-touch:swipe.left="swipeHandler('task__title__' + task.id)"
          :class="'task__title__' + task.id"
          class="field-value exclude-outside-click text-hover-bg"
          v-show="!titleEditing"
          :title="task.title"
        >
          <span :style="taskStatusColor(task)" class="gesture__delete__left" :class="showRemoveIndicatorLeft ? 'active' : ''">
            <i class="fas fa-trash"></i>
          </span>
          <span class="reorder-drag-icon" style="width:1rem;">&nbsp;</span>
          {{ task.title }}
          <span :style="taskStatusColor(task)" class="gesture__delete__right" :class="showRemoveIndicatorRight ? 'active' : ''">
            <i class="fas fa-trash"></i>
          </span>
        </span>
        <div class="custom-field">
          <input
            ref="customInput"
            v-click-outside="outside"
            v-show="titleEditing"
            type="text"
            @change="updateFieldValue(task)"
            @blur="titleEditing = false"
            @keyup.enter="titleEditing = false"
            v-model="task.title"
            class="form-control title-field"
          />
        </div>
      </div>
      <i @click="$emit('toggleTaskFields', task.id); chevronClass = !chevronClass" :class="chevronClass ? 'fa-chevron-down' : 'fa-chevron-up'" class="fas toggle-task-chev"></i>
    </div>
  </div>
</template>

<script>
import toast from "../../toast";
import { mapActions, mapGetters, mapState } from "vuex";
import SortTaskControl from '../common/SortTaskControl'
export default {
  data() {
    return {
      addingTask: false,
      showRemoveTask: false,
      showRemoveTaskErr: false,
      showRemoveApprovalTaskErr: false,
      showRemovePublishTaskErr: false,
      titleEditing: false,
      chevronClass: true,
      showRemoveIndicatorRight: false,
      showRemoveIndicatorLeft: false,

      removeButtonClickedOnce: false,
    };
  },
  props: ["task", "index", "deliverableId", "deliverable", "totalTasks", "fullDeliverables", "namespace"],
  components: {
    SortTaskControl
  },
  computed: {
    ...mapGetters([ "userAbilities"]),
    ...mapState({
  	  state (state) {
  	    return state[this.namespace]
  	  },
  	  allDeliverables (state, getters) {
  	    return getters[this.namespace + 'allDeliverables']
  	  },
  	  userDeliverables (state, getters) {
  	    return getters[this.namespace + 'userDeliverables']
  	  },
  	}),
  },
  methods: {
    ...mapActions({
      updateFieldValue (dispatch, payload) {
        return dispatch(this.namespace + 'updateFieldValue', payload)
      },
    }),
    getSortingClass() {
      return this.$store.state.deliverables.storedSortKey == 'created_date' ? `${this.$store.state.deliverables.storedSortState}-created-date` : ''
      // let currentSortKey = localStorage.getItem('storedSortKey')
      // let currentSortState = localStorage.getItem('storedSortState')
      // return currentSortKey == 'created_date' ? `${currentSortState}-created-date` : ''
    },
    removeDeleteIcons() {
      this.showRemoveIndicatorRight = false;
      this.showRemoveIndicatorLeft = false;
    },
    swipeHandler(taskTitleClass) {
      let self = this;
      return function(direction, event) {
        self.showRemoveTask = true;
        if(direction == 'left') {
          self.showRemoveIndicatorLeft = true;
          self.showRemoveIndicatorRight = false;
        } else {
          self.showRemoveIndicatorRight = true;
          self.showRemoveIndicatorLeft = false;
        }
        // $('.' + taskTitleClass + ' .gesture__delete__' + direction).toggleClass('active');
      }
    },
    taskStatusColor(task) {
      let taskStatusField = _.filter(task.taskFields, {field_key: 'status'});
      if (taskStatusField) {
        if ((Array.isArray(taskStatusField) && taskStatusField.length)) {
          let bgColor = typeof taskStatusField[0].value == 'string' ?
            JSON.parse(taskStatusField[0].value).color :
            taskStatusField[0].value.color;
          return { backgroundColor: bgColor };
        }
      }
	    return {backgroundColor: "var(--wf-tertiary)"};
    },
    createTask() {
      let self = this;
      this.addingTask = true;
      this.$store.dispatch(self.namespace + "createTask", this.deliverableId).then(function(r) {
        self.addingTask = false;
        self.$store.dispatch(self.namespace + 'manageUndoActivationNoScroll', 'Task has been created.');

        // Focus on task title
        if (r) {
          let newTaskId = r;
          if (self.$router.currentRoute.name == 'projectDeliverable') {
            self.$store.dispatch(self.namespace + "fetchProjectDeliverable").then(() => {
              $(`.field-value.exclude-outside-click.text-hover-bg.task__title__${newTaskId}`).trigger('click');
              $(`.field-value.exclude-outside-click.text-hover-bg.task__title__${newTaskId}`).siblings(".custom-field").find(".form-control.title-field")[0].select();
            })
          } else {
            self.$nextTick(() => {
              $(`.field-value.exclude-outside-click.text-hover-bg.task__title__${newTaskId}`).trigger('click');

              if ($('#editDeliverableModal').length) {
                $(`#editDeliverableModal .field-value.exclude-outside-click.text-hover-bg.task__title__${newTaskId}`).siblings(".custom-field").find(".form-control.title-field")[0].select();
              } else if ($('#editDeliverableModalAlert').length) {
                $(`#editDeliverableModalAlert .field-value.exclude-outside-click.text-hover-bg.task__title__${newTaskId}`).siblings(".custom-field").find(".form-control.title-field")[0].select();
              } else {
                $(`.field-value.exclude-outside-click.text-hover-bg.task__title__${newTaskId}`).siblings(".custom-field").find(".form-control.title-field")[0].select();
              }
            });
          }
        }
      });
    },
    removeTask(taskId) {
      let self = this;
      
      this.$store.dispatch(self.namespace + "removeTask", {dtTaskId: taskId, deliverableTemplateId: this.deliverableId})
      .then(function(response) {

        if(response) {
            self.$store.dispatch(self.namespace + 'fetchDeliverableTemplateNoScroll');
            self.$store.commit(self.namespace + "setDeliverableTemplateDetail", response);
            self.$store.dispatch(self.namespace + 'manageUndoActivationNoScroll', 'Task has been deleted.');
        } else {
            self.showRemoveTaskErr = true
        }
      });   

    },
    showField() {
      if(typeof this.userAbilities.editMediaCall == 'undefined' || !this.userAbilities.editMediaCall || this.deliverable.permissions.viewOnly) return;
      this.removeButtonClickedOnce = false;

      let currentDeliverableList = [];
      if(this.$router.currentRoute.name == 'dashboard') {
        currentDeliverableList = this.allDeliverables;
      } else if(this.$router.currentRoute.name == 'myWeek') {
        currentDeliverableList = this.allDeliverables;
      }
      for (let x = 0; x < Object.keys(currentDeliverableList).length; x++) {
        if(currentDeliverableList[x].id == this.deliverableId) {
          if(currentDeliverableList[x].permissions.viewOnly) return;
        }
      }
      this.titleEditing = true;
      this.$nextTick(() => {
        if (typeof this.$refs.customInput != "undefined") {
          this.$refs.customInput.focus()
          this.$refs.customInput.select()
        }
      });
    },
    outside: function() {
      this.titleEditing = false;
    },

    deleteTaskClick() {
      if(
        this.task.task_type_id == process.env.MIX_APP_TASK_TYPE_CONTENT_APPROVAL ||
        this.task.task_type_id == process.env.MIX_APP_TASK_TYPE_SCHEDULE_APPROVAL
      ){
        //this.showRemoveApprovalTaskErr = true;
        toast.error(
          "Approval tasks for social media deliverables can not be removed."
        );
      } else if (this.task.task_type_id == process.env.MIX_APP_TASK_TYPE_PUBLISH){
        //this.showRemovePublishTaskErr = true;
        toast.error(
          "Publishing tasks for social media deliverables can not be removed."
        );
      } else if (this.isMobile()) {
        if (this.removeButtonClickedOnce) {
          this.showRemoveTask = true;
        } else {
          this.removeButtonClickedOnce = true;
        }
      } else {
        this.showRemoveTask = true;
      }
    },
    deleteOutside() {
      this.removeButtonClickedOnce = false;
    }
  },
  mounted() {
    let self = this;
    window.addEventListener("keyup", function(e) {
      if (e.keyCode === 27) {
        self.titleEditing = false;
      }
    });
  }
};
</script>

<style scoped>
input[type="text"] {
	font-size:16px;
	}

.task-title.field-value {
	padding-top: 21px;
padding-left: 20px;
}
	input[type="text"].form-control.title-field {
	font-size:16px;
	}

	.reorder-drag-icon {
		background:url("/images/reorder-list-with-arrows.svg") no-repeat center/contain;
		display:inline-block;
		opacity:0;
	  transition: all 1ms;
/*	  padding-right:1rem;*/

	  padding-right: 0rem;
  	float: right;
	  margin-right: 1rem;

	}

	.field-control-wrapper .field-wrap:not(.disabled):hover .reorder-drag-icon {
	  opacity: 0.5;
	  transition: all 1ms;
	}


</style>
